import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { JQLSyntaxError } from '@atlaskit/jql-ast';
import getDocumentPosition from '../common/get-document-position';
import { getJastFromState } from '../jql-ast';
import { JQLValidationTooltipPluginKey, TOOLTIP_CLASSNAME, TOOLTIP_ENTER_CLASSNAME, TOOLTIP_EXIT_CLASSNAME } from './constants';
export var ValidationTooltipPluginView = /*#__PURE__*/function () {
  function ValidationTooltipPluginView(mainId) {
    var _this = this,
      _document$getElementB;
    _classCallCheck(this, ValidationTooltipPluginView);
    _defineProperty(this, "showTooltip", function (error, start, end) {
      var _this$tooltip$offsetP, _box$left, _box$top;
      // Find a center position from the selection endpoints
      var left = (start.left + end.left) / 2;

      // The box in which the container is positioned, to use as base
      var box = (_this$tooltip$offsetP = _this.tooltip.offsetParent) === null || _this$tooltip$offsetP === void 0 ? void 0 : _this$tooltip$offsetP.getBoundingClientRect();
      _this.tooltip.style.left = "".concat(left - ((_box$left = box === null || box === void 0 ? void 0 : box.left) !== null && _box$left !== void 0 ? _box$left : 0), "px");
      _this.tooltip.style.top = "".concat(start.top - ((_box$top = box === null || box === void 0 ? void 0 : box.top) !== null && _box$top !== void 0 ? _box$top : 0), "px");
      _this.tooltip.textContent = error.message;
      _this.tooltip.classList.remove(TOOLTIP_EXIT_CLASSNAME);
      _this.tooltip.classList.add(TOOLTIP_ENTER_CLASSNAME);
    });
    _defineProperty(this, "hideTooltip", function () {
      _this.tooltip.classList.remove(TOOLTIP_ENTER_CLASSNAME);
      _this.tooltip.classList.add(TOOLTIP_EXIT_CLASSNAME);
    });
    this.tooltip = document.createElement('div');
    this.tooltip.setAttribute('data-testid', 'jql-validation-tooltip');
    this.tooltip.classList.add(TOOLTIP_CLASSNAME);
    (_document$getElementB = document.getElementById(mainId)) === null || _document$getElementB === void 0 || _document$getElementB.appendChild(this.tooltip);
  }
  return _createClass(ValidationTooltipPluginView, [{
    key: "update",
    value: function update(view, lastState) {
      var state = view.state;
      var isHovered = JQLValidationTooltipPluginKey.getState(state);
      var lastIsHovered = JQLValidationTooltipPluginKey.getState(lastState);
      var jast = getJastFromState(state);
      var _jast$errors = _slicedToArray(jast.errors, 1),
        error = _jast$errors[0];
      if (isHovered === lastIsHovered) {
        return;
      }
      if (isHovered) {
        if (error instanceof JQLSyntaxError) {
          var start = getDocumentPosition(state.doc, error.start);
          var stop = getDocumentPosition(state.doc, error.stop);
          var startCoords = view.coordsAtPos(start);
          var stopCoords = view.coordsAtPos(stop);
          this.showTooltip(error, startCoords, stopCoords);
        }
      } else {
        this.hideTooltip();
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.tooltip.remove();
    }
  }]);
}();